export const signupFields = [
  {label: '活动名称', value: '', key: 'joinActivityTitle'},
  {label: '费用', value: '', key: 'joinActivityAmount'},
  {label: '用户名称', value: '', key: 'joinUserName'},
  {label: '联系方式', value: '', key: 'userPhone'},
  {label: '报名时间', value: '', key: 'signUpDate'},
]
export const lotteryFields = [
  {label: '活动名称', value: '', key: 'activityName'},
  {label: '姓名', value: '', key: 'contactsName'},
  {label: '联系方式', value: '', key: 'contactsPohone'},
  {label: '奖品', value: '', key: 'prizeName'},
  {label: '中奖时间', value: '', key: 'createdTime'},
]
export const spikeFields = [
  {label: '活动名称', value: '', key: 'activityName'},
  {label: '姓名', value: '', key: 'contactsName'},
  {label: '联系方式', value: '', key: 'contactsPhone'},
  {label: '商品', value: '', key: 'goodsName'},
  {label: '秒杀时间', value: '', key: 'createdTime'},
  {label: '实付价格', value: '', key: 'goodsPrice'},
]
export const groupFields = [
  {label: '活动名称', value: '', key: 'activityName'},
  {label: '姓名', value: '', key: 'contactsName'},
  {label: '联系方式', value: '', key: 'contactsPhone'},
  {label: '商品', value: '', key: 'goodsName'},
  {label: '拼团时间', value: '', key: 'createdTime'},
  {label: '订单号', value: '', key: 'orderNo'},
  {label: '状态', value: '', key: 'status'},
  {label: '实付价格', value: '', key: 'goodsPrice'},
]
export const drawLotsFields = [
  {label: '活动名称', value: '', key: 'activityName'},
  {label: '奖品名称', value: '', key: 'prizeName'},
  {label: '兑奖时间', value: '', key: 'createdTime'}
]

export const countMoneyFields = [
  {label: '活动名称', value: '', key: 'activityName'},
  {label: '奖品名称', value: '', key: 'prizeName'},
  {label: '奖品类型', value: '', key: 'prizeType'},
  {label: '中奖时间', value: '', key: 'createdTime'},
]

export const couponFields = [
  {label: '优惠券名称', value: '', key: 'couponName'},
  {label: '用户名称', value: '', key: 'contactsName'},
  {label: '联系方式', value: '', key: 'contactsPhone'},
  {label: '领劵时间', value: '', key: 'createdTime'},
]


